<template>
  <div class="flex flex-col">
    <div v-for="i in rowCount" :key="i" class="flex items-center gap-12 p-16 w-full rounded-none">
      <div class="w-24 h-24 flex-shrink-0 rounded-full animate-pulse bg-grey-divider-subdued" />
      <div class="min-w-0 flex-1 space-y-8">
        <div class="flex items-center justify-between gap-8">
          <div class="h-16 flex-1 max-w-[50%] animate-pulse rounded bg-grey-divider-subdued" />
          <div class="h-12 w-32 animate-pulse rounded bg-grey-divider-subdued" />
        </div>
        <div class="h-12 w-full animate-pulse rounded bg-grey-divider-subdued" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ChannelListSkeleton',
  props: {
    rowCount: {
      type: Number,
      default: 5,
    },
  },
};
</script>
